import { IRightSideBarService } from '../../right-side-bar-service/core/interface';

export interface INotifyManager {
    notifyNumbers: number;
    show(): void;
    showNotifyModule(domNode: HTMLElement, onShow?: () => void, onHide?: () => void): void;
    hideNotifyContainer(): void;
    setServiceDelegates(services: Partial<INotifyManagerServiceDelegates>): void;
    setInject(injectable: INotifyManagerInjectable);
    registerRightSideBar(): void;
}

export interface INotifyManagerInjectable {
    customNodeStyle: Partial<CSSStyleDeclaration>;
}

export const MODULE_NAME = 'notify';

export const NOTIFICATION_CENTER = 'notification-container';

export interface INotifyManagerServiceDelegates {
    rightSideBarService: IRightSideBarService
}
